import { DATEFORMAT, CvDateFormatter } from '@cv-invision/cv.component-library.ux';

/**
 * Defines the columns
 * And any action against the columns
 */
export class CallbackLogsXpanseColumnsModel {
	private _columns: Array<any>;
	constructor(dateService:CvDateFormatter) {
		this._columns = [
			{
				headerName: 'Transaction',
				field: 'transactionId',
				width: 130
			},
			{
				headerName: 'Xpanse SPN ID',
				field: 'xpanseSPNId',
				width: 260
			},
			{
				headerName: 'Xpanse Transaction ID',
				field: 'xpanseTransactionId',
				width: 270
			},
			{
				headerName: 'Class Order ID',
				field: 'orderId',
				width: 60
			},
			{
				headerName: 'Event Name',
				field: 'eventName',
				width: 90
			},
			{
				headerName: 'Status',
				field: 'status',
				width: 90
			},
			{
				headerName: 'Duration',
				field: 'duration',
				width: 60,
				cellRenderer: 'suffixCellRenderer',
				cellRendererParams: { suffix: 'ms', fieldName: 'duration' }
			},
			{
				headerName: 'Received',
				field: 'created',
				width: 140
			},
			{
				headerName: 'Received (Local)',
				field: 'created',
				width: 160,
				valueFormatter: params =>  dateService.format(DATEFORMAT.EMPTY,params.data.created)
			}
		];
	}

	get columns(): Array<any> {
		return this._columns;
	}
}
